import { render, staticRenderFns } from "./index.vue?vue&type=template&id=36cb5f26"
import script from "./userDetails.js?vue&type=script&lang=js&external"
export * from "./userDetails.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports